import $ from 'jquery';

var hash = location.hash;
if(hash !== '' && $(hash).length > 0) {
    window.scrollTo({
        top: $(hash).offset().top - $('.header').outerHeight(),
        behavior: 'smooth'
    });
}